import { css } from '@emotion/react';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import type {
  FC, ReactNode,
} from 'react';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import { LimitNumberOfLinesComponent } from '~/_shared/components/limitNumberOfLines/limitNumberOfLines.component';
import type { Theme } from '~/_shared/themes/theme.model';

const wrapperStyle = ({ isActive }: { isActive: boolean }) => (theme: Theme) => css({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  justifyContent: 'right',
  background: isActive ? theme.buttonColors.primaryBackground : 'none',
  border: 'none',
  color: isActive ? theme.textColors.quaternary : theme.textColors.primary,
  fontSize: '12px',
  height: '100%',
  padding: '0 10px',
  transition: 'background .1s',
  '&:hover': {
    background: theme.buttonColors.primaryBackground,
    color: theme.textColors.quaternary,
  },
});

const caretDownIconStyle = (isDropdownOpen: boolean) => css({
  display: 'flex',
  alignItems: 'center',
  float: 'right',
  fontSize: 16,
  justifyContent: 'center',
  transform: isDropdownOpen ? 'rotate(-180deg)' : undefined,
  transition: 'transform .2s',
});

type SettingsAccordionDropdownComponentProps = Readonly<{
  isOpen: boolean;
  triggerText?: string;
  children?: ReactNode;
  onClick: () => void;
}>;

export const SettingsAccordionDropdownComponent: FC<SettingsAccordionDropdownComponentProps> = (props) => {
  return (
    <div
      css={wrapperStyle({ isActive: props.isOpen })}
      onClick={props.onClick}
    >
      {!!props.children && (
        <div>
          {props.children}
        </div>
      )}
      {props.triggerText && (
        <LimitNumberOfLinesComponent maxNumberOfLines={2}>
          {props.triggerText}
        </LimitNumberOfLinesComponent>
      )}
      <div css={caretDownIconStyle(props.isOpen)}>
        <FontAwesomeIcon icon={faCaretDown} />
      </div>
    </div>
  );
};
